/**
 * One clickable upgrade card, shared by the radio and checkbox column
 * selectors. The visually-hidden form control that actually reflects the
 * selection is passed in as `control`, since only the caller knows whether
 * that's a radio or a checkbox.
 */
export default function OptionCard({
  selected,
  onClick,
  title,
  titleFor,
  titleClassName = '',
  priceDifference,
  control,
  description,
  className = '',
  rowClassName = '',
  ...buttonProps
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`hover:bg-parlor-green-95 w-full cursor-pointer border-2 p-3 text-left transition-colors duration-100 ${selected ? 'border-light-green bg-parlor-green-95' : 'bg-parlor-green border-parlor-green-80'} ${className}`}
      {...buttonProps}
    >
      <div className={`flex justify-between ${rowClassName}`}>
        <label
          className={`sh12 text-white ${titleClassName}`}
          htmlFor={titleFor}
        >
          {title}
        </label>
        <div className="flex items-center">
          {priceDifference && (
            <span className="price-s-form mr-2">{priceDifference}</span>
          )}
          {control}
        </div>
      </div>
      {description && (
        <p className="body-s mt-2 max-w-70 text-white">{description}</p>
      )}
    </button>
  );
}
